import React, { useEffect, useState} from 'react';
import { HeartIcon, HeartIconFilled } from 'components/Icons';
import Avatar from 'components/Avatar';
import { useDispatch, useSelector } from 'react-redux';
import Linkify from 'react-linkify';
import { USER_PROFILE } from 'constants/routes';
import { Link, useLocation } from 'react-router-dom';
import moment from 'moment';
import PostActionItem from 'components/generic-components/post/PostActionItem';
import ButtonComponent from 'components/generic-components/ButtonComponent';
import { useTranslation } from 'react-i18next';
import useToggle from 'utils/customHooks/useToggle';
import { renderTime } from 'utils/functions';
import { commentLikeOnPost ,replyLikeOnPost} from '../../../reducers/feed/feed.actions';

const PostComment = ({ el, replyClick, replyHandler, fromFeed }) => {
  const {pathname} = useLocation();
  const forFeed = !pathname.includes('post');
  const { t } = useTranslation();
  const [likedComment, setLikedComment] = useToggle(false);
  const time = renderTime(el.createdAt);
  const dispatch = useDispatch();
  const [resp, setResp] = useState(true);

  const [showReplies, setShowReplies] = useState(1);
  const handleLikeToggleComment = id => {
    setLikedComment()
    dispatch(commentLikeOnPost(id)).then(resp => {
      setResp(true);
    })
      .catch(err => {
        throw err;
      });
  };
  const handleLikeToggleReply = id => {
    setLikedComment()
    dispatch(replyLikeOnPost(id,el.id,forFeed)).then(resp => {
      setResp(true);
    })
      .catch(err => {
        throw err;
      });
  };
  
 const commentBody = <Linkify
    componentDecorator={(
      decoratedHref,
      decoratedText,
      key,
    ) => (
      <a className="comment-body-href" href={decoratedHref} key={key} target="_blank">
        {decoratedText}
      </a>
    )}
  >
    {el.body}
  </Linkify>;

  return (
    <div key={el.id} className={`d-flex my-3 ${el.isReply ? 'ml-5' : ''} `}>
      <Avatar style={{ fontSize: '10px' }} user={el.user && el.user.name} size={32} image={el.user.avatar} isOnline={el.user.is_online} className="comments-small-avatar" />
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        <div style={{ display: 'flex', width: '100%' }}>
          <div className="flex-grow-1 position-relative" >
            <div className='user-name-comment-container'> 
            <div className="d-flex">
              <Link
                className="d-flex align-items-center color-transparent"
                to={USER_PROFILE.replace(':userId?', el.user.id).replace(
                  ':name?',
                  !!el.user.nickname ? el.user.nickname : ''
                )}
              >
                {!!el.user.name ? (
                  <p className="username-comment">{el.user.name}</p>
                ) : (
                  <p className="username-comment">{el.user.nickname}</p>
                )}
              </Link>
            </div>
            <pre className="comment-body-text">{commentBody}</pre>
            </div>
            <div className={'d-flex mt-2'}>
              <p className="time-text">
                {time.actualTime} {t(`${time.text}`)}
              </p>
              <p className={el.liked ? 'did-like' : 'no-like'} onClick={() => handleLikeToggleComment(el.id)}>
               {t('Like')}
              </p>
              <p className="no-like" onClick={replyClick}>
              {t('Reply')}
              </p>

             <div className='comment-red-hurt'>  
             {el.likes_count > 0 && el.likes_count}
               <PostActionItem
            icon={el.liked ? HeartIconFilled : HeartIcon}
            // height={11}
           
           
          />
          </div>
            </div>
          </div>    
        </div>
        {el.replies && el.replies.length > 1 && showReplies < el.replies.length && (
          <div className="replies-controller" onClick={() => setShowReplies(oldState => (oldState += 10))}>
            {showReplies >= 11 ? "View previous replies" : "View all replies"}
          </div>
        )}
        {el.replies &&
          el.replies.slice(Math.max(el.replies.length - showReplies, 0)).map((reply, idx) => {
            const replyBody = <Linkify
              componentDecorator={(
                decoratedHref,
                decoratedText,
                key,
              ) => (
                <a className="comment-body-href" href={decoratedHref} key={key} target="_blank">
                  {decoratedText}
                </a>
              )}
            >
              {reply.body}
            </Linkify>;
            
            let replyTime = renderTime(reply.createdAt)
            return (
              <div style={{ display: 'flex', width: '100%', marginTop: '10px' }}>
                <Avatar style={{ fontSize: '10px' }} user={reply.user && reply.user.name} size={32} image={reply.user.avatar} isOnline={reply.user.is_online} className="comments-small-avatar" />
                <div className="flex-grow-1 position-relative">
                <div className='user-name-comment-container'> 
                  <div className="d-flex">
                    <Link
                      className="d-flex align-items-center color-transparent"
                      to={USER_PROFILE.replace(':userId?', reply.user.id).replace(
                        ':name?',
                        !!reply.user.nickname ? reply.user.nickname : ''
                      )}
                    >
                      {!!reply.user.name ? (
                        <p className="username-comment">{reply.user.name}</p>
                      ) : (
                        <p className="username-comment">{reply.user.nickname}</p>
                      )}
                    </Link>
                  </div>
                  <pre className="comment-body-text">{replyBody}</pre>
                    </div>
                  <div className={'d-flex mt-1'}>
                    <p className="time-text">
                      {t(`${replyTime.actualTime}`)} {t(`${replyTime.text}`)}
                    </p>

                    
                    <p className={reply.liked ? 'did-like' : 'no-like' } onClick={() => handleLikeToggleReply(reply.id)}>
               {t('Like')}
              </p>
              <p className=" no-like"  onClick={() => replyHandler(reply)}>
              {t('Reply')}
              </p>
                    <div className='d-flex comment-red-hurt'> 
                    {reply.likes_count > 0 && reply.likes_count} 
                    <PostActionItem
                  icon={reply.liked ? HeartIconFilled : HeartIcon}
                />
                </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default PostComment;
